<template>
    <rc-in-app-notice-dialog
        v-if="!never_show"
        ref="notice"
        notice_type="red-chirp-agreements-organization-admin-all-agreements-rev-2026-01-01"
        notice_location="home"
        title="We Have Updated Our Agreements for 2026"
        complete_text="Accept"
        max-width="920"
        :loading="loading"
        :persistent="false"
        :can_complete="is_signed"
        @shown="onShown"
        @complete="onSign"
    >
    <div class="py-3 px-4">
        <p>For details on what has changed and why <a v-on:click="onClickDetails()" style="text-decoration: underline">click here</a>.</p>

        <m-sign-packet
            agreement_type="accept-above-agreements-with-org-sub-agreement"
            :organization_id="$rc.$state.getOrganizationId()"
            :meta_data="meta_data"
            v-model="is_signed"
            ref="sign-packet-dialog"
        />
    </div>
    </rc-in-app-notice-dialog>
</template>

<script>

export default {

    data() {
        return {
            loading: false,

            check: null,
            meta_data: [],
            is_signed: false,
            employee_id: null,
        }
    },

    computed: {
        never_show() {
            // Don't ask a system admin to sign for someone else...
            // back end should handle, but just in case
            return this.$rc.$state.isAuthActorSystemAdmin() && this.$rc.$state.isActingAsSomoneElse();
        }
    },

    methods: {
        onShown()
        {
            this.loading = true;
            this.is_signed = false;
            this.employee_id = this.$rc.$state.getEmployeeId();

            this.$rc.rest({
                spinner: false,
                endpoint: 'GET: /api/v1/signatures/packets/current-org-admin-all-agreements',
            
                params: {
                },
            
                on_success: (check) => {
                    this.check = check;
                    this.getBlobMetaData();
                },
            
                on_error: () => {
                    this.loading = false;
                    this.killDialog();
                }
            });
        },

        getBlobMetaData()
        {
            if ( this.check == null ) {
                this.killDialog();
                return;
            }

            this.$rc.getBlobMetaDataMultiple(
                this.check.current_packet.blob_ids,

                (data) => {
                    this.loading = false;
                    this.meta_data = data.meta_data;
                },

                () => {
                    this.loading = false;
                    this.killDialog();
                }
            )
        },

        onClickDetails()
        {
            window.open(this.$router.resolve({
                'name': 'public-updated-agreements-2026-announcement',
                'params' : {
                }
            }).href, '_blank');
        },

        onSign()
        {
            this.$rc.rest({
                spinner: false,
                endpoint: 'PUT: /api/v1/signatures/sign-agreement',
            
                params: {
                    packet_id: this.check.current_packet.packet_id,
                    signed_by_employee_id: this.$rc.$state.getEmployeeId(),
                    agreement_specimen: '[X] '+this.$refs['sign-packet-dialog'].getSpecimen(),
                },
        
                on_success: (data) => {
                    // no-op
                },
            
                on_error: 'Unable to sign agreement(s)',
            });            
        },

        killDialog() {
            if (this.$refs['notice']?.closeDialog) {
                this.$refs['notice'].closeDialog();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
</style>